/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Traces_Empty_DescriptionInputs */

const es_admin_traces_empty_description = /** @type {(inputs: Admin_Traces_Empty_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intentá ajustar los filtros o el rango de fechas.`)
};

const en_admin_traces_empty_description = /** @type {(inputs: Admin_Traces_Empty_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try adjusting filters or date range.`)
};

/**
* | output |
* | --- |
* | "Try adjusting filters or date range." |
*
* @param {Admin_Traces_Empty_DescriptionInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_traces_empty_description = /** @type {((inputs?: Admin_Traces_Empty_DescriptionInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Traces_Empty_DescriptionInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_traces_empty_description(inputs)
	return en_admin_traces_empty_description(inputs)
});
export { admin_traces_empty_description as "admin.traces.empty.description" }